const getNameInitials = (name: string) => {
  const splittedName = name?.split(" ")
  if (splittedName?.length >= 2) {
    return `${splittedName[0][0]}${splittedName[1][0]}`
  }
  return `${splittedName?.[0][0]}`
}
export default getNameInitials

export const flags = {
  DebugProd: false,
  appleLogin: true,
  appleLoginDesktop: true,
  callModule: true,
  channelModule: true,
  chatModule: true,
  googleLogin: true,
  matrixUserPresenceStatus: true,
  microsoftLogin: true,
  webPhone: true,
  webinar: true
}

export const capitalize = (str) => {
  if (typeof str !== "string" || !str.trim()) return ""
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const convertDecimalToTime = (decimal = 0) => {
  const totalSeconds = Math.round(decimal * 60)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const paddedHours = hours.toString().padStart(2, "0")
  const paddedMinutes = minutes.toString().padStart(2, "0")
  const paddedSeconds = seconds.toString().padStart(2, "0")

  return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`
}
